import {
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  isAfter,
  isSameDay,
  isSameMonth,
  startOfDay,
  startOfMonth,
  startOfWeek,
} from 'date-fns';

import { MIN_BIRTH_YEAR } from './constants';

export const getCalendarDays = (viewDate: Date): Date[] => {
  const monthStart = startOfMonth(viewDate);
  const monthEnd = endOfMonth(viewDate);

  return eachDayOfInterval({
    start: startOfWeek(monthStart, { weekStartsOn: 0 }),
    end: endOfWeek(monthEnd, { weekStartsOn: 0 }),
  });
};

export const isDaySelectable = (day: Date, today: Date) => !isAfter(startOfDay(day), startOfDay(today));

export const isDayOutsideMonth = (day: Date, viewDate: Date) => !isSameMonth(day, viewDate);

export const isDaySelected = (day: Date, selected: Date | null) => selected !== null && isSameDay(day, selected);

export const isDayToday = (day: Date, today: Date) => isSameDay(day, today);

export const buildYearOptions = (maxYear: number) => {
  const years: number[] = [];
  for (let year = maxYear; year >= MIN_BIRTH_YEAR; year -= 1) {
    years.push(year);
  }
  return years;
};
